import * as API from '@siloreal:shared:api';

const SILOBAG_TAG_LIST_ENDPOINT = '/tags/silobag_tags/silobag';

export type SilobagTagListServiceContract = {
  query: string;
  signal?: AbortSignal;
};

export async function listSilobagTagsService(
  contract: SilobagTagListServiceContract
): Promise<SilobagTagListResponse> {
  const query = `/${encodeURIComponent(contract.query)}`;
  const { data } = await API.http.fetch.get<SilobagTagListResponse>(SILOBAG_TAG_LIST_ENDPOINT, {
    query,
    signal: contract.signal,
  });

  return data;
}

export type SilobagTagListResponse = {
  error: boolean;
  response: SilobagTagListScope[];
};

export type SilobagTagListScope = {
  scope: 'organization' | 'system';
  tags: SilobagTagListEntry[];
};

export type SilobagTagListEntry = {
  tag: SilobagTagListTag;
  selected: boolean;
};

export type SilobagTagListTag = {
  id: number;
  label: string;
  bg_color: string;
  text_color: string;
  scope: { value: 'organization' | 'system' };
  translations: SilobagTagListTranslation[];
  active: boolean;
  image_url?: string;
  created_at: string;
  updated_at: string;
};

export type SilobagTagListTranslation = {
  language: string;
  value: string;
  tooltip: string;
};
